export const toCamelCase = (str) =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '')

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength - 3)}...`
  }

  return text
}

export const isEncoded = (str) => {
  try {
    return str !== decodeURIComponent(str)
  } catch (e) {
    return false
  }
}
